import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LicenseUsersService } from '@portal-core/license-users/services/license-users.service';
import { Team } from '@portal-core/teams/models/team.model';
import { TeamsService } from '@portal-core/teams/services/teams.service';
import { TeamPageFilterConfig } from '@portal-core/teams/util/team-page-filter-config';
import { ListControl } from '@portal-core/ui/list/util/list-control';
import { ListBase } from '@portal-core/ui/list/util/list.base';
import { of } from 'rxjs';
import { ListComponent } from '@portal-core/ui/list/components/list/list.component';
import { ListItemDirective } from '@portal-core/ui/list/directives/list-item/list-item.directive';
import { MatListItem } from '@angular/material/list';
import { TeamAvatarComponent } from '@portal-core/teams/components/team-avatar/team-avatar.component';
import { NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { EmptyListDirective } from '@portal-core/ui/list/directives/empty-list/empty-list.directive';
import { AllItemsLoadedListDirective } from '@portal-core/ui/list/directives/all-items-loaded-list/all-items-loaded-list.directive';
import { IncludedInPipe } from '@portal-core/general/pipes/included-in/included-in.pipe';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'mc-license-user-teams-list',
    templateUrl: './license-user-teams-list.component.html',
    styleUrls: ['./license-user-teams-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ListComponent, ListItemDirective, MatListItem, TeamAvatarComponent, NgIf, MatIconButton, MatIcon, EmptyListDirective, AllItemsLoadedListDirective, IncludedInPipe, MatTooltip]
})
export class LicenseUserTeamsListComponent extends ListBase<Team> implements OnChanges {
  readonly collectionService = inject(TeamsService);
  private readonly licenseUsersService = inject(LicenseUsersService);
  private readonly snackBar = inject(MatSnackBar);
  @Input() licenseUserId: number;
  @Input() canEdit: boolean = false;

  @Output() saved: EventEmitter<void> = new EventEmitter<void>();

  removing: number[] = [];

  override filterConfig: TeamPageFilterConfig = new TeamPageFilterConfig(['Name']);

  listControl: ListControl<Team> = new ListControl<Team>(this.collectionService, filter => {
    if (typeof this.licenseUserId === 'number') {
      return this.licenseUsersService.getTeams$(this.licenseUserId, filter);
    } else {
      return of(null);
    }
  });

  ngOnChanges(changes: SimpleChanges) {
    if (changes.licenseUserId) {
      this.hardReload();
    }
  }

  onRemoveTeam(teamId: number) {
    this.removing = [
      ...this.removing,
      teamId
    ];
    this.collectionService.removeUserFromTeam$(this.licenseUserId, teamId).subscribe(() => {
      this.collectionService.removePagedDataListItems$(this.dataListId, [teamId]);
      this.removing = this.removing.filter(id => id !== teamId);
      this.saved.emit();
    }, () => {
      this.removing = this.removing.filter(id => id !== teamId);
      this.snackBar.open('Unable to remove the user from the team.', 'OK');
    });
  }
}
